import React from "react";
import TextareaComponent from "./TextareaComponent";
import ToggleComponent from "./ToggleComponent";
import useLogin from "@common/components/hooks/useLogin";

const ToggleTextareaComponent = ({
  control,
  register,
  watch,
  toggleName,
  toggleLabel,
  toggleError,
  textareaName,
  textareaPlaceholder,
  textareaError,
}) => {
  const toggleValue = watch(toggleName, false);
  const [{ isInReadMode }] = useLogin();
  return (
    <>
      <ToggleComponent
        control={control}
        name={toggleName}
        label={toggleLabel}
        error={toggleError}
      />
      {toggleValue !== null && toggleValue === false && (
        <TextareaComponent
          name={textareaName}
          placeholder={textareaPlaceholder}
          register={register}
          readOnly={isInReadMode}
          error={textareaError}
        />
      )}
    </>
  );
};

export default ToggleTextareaComponent;
